import { observable } from "mobx";
import { Type } from "class-transformer";
import EnforcementUserType from "./enforcementUserType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class EnforcementTabletUserDetailResponse {
  /**
   * User ID.
   */
  id!: string;

  /**
   * User personal code.
   */
  @observable
  code!: string;

  @observable
  userType!: EnforcementUserType;

  @observable
  pin?: string;
  /**
   * Indicates if user is manager.
   */
  @observable
  isManager!: boolean;

  /**
   * Date and time of user creation.
   */
  @observable
  @Type(() => Date)
  createdAt!: Date;

  /**
   * Full name of the person who created the user.
   */
  @observable
  createdBy?: string;

  /**
   * Date and time of last user update.
   */
  @observable
  @Type(() => Date)
  updatedAt!: Date;

  /**
   * Full name of the person who last modified the user.
   */
  @observable
  updatedBy?: string;
}
